<div
  class="date-picker-input-container"
  [class.has-error]="hasError"
  [style.borderColor]="borderColour"
  *ngIf="!inline; else inlineCalendar"
>
  <input
    matInput
    [matDatepicker]="picker"
    [formControl]="dateControl"
    class="date-picker-input form-control"
    #dp="matInput"
    [class.pointer]="!allowTyping"
    [class.disabled]="disableControl"
    [readonly]="!allowTyping || disableControl"
    [placeholder]="placeholder"
    [ngStyle]="{ height: inputHeight, marginTop: marginTop }"
    (dateChange)="onDateChanged($event)"
    [min]="minDate"
    [max]="maxDate"
    [matDatepickerFilter]="matFilter"
    [attr.disabled]="disableControl ? '' : null"
    (click)="onInputClick(picker)"
    (blur)="handleBlur($event)"
    (focus)="handleFocus($event)"
  />

  <mat-datepicker #picker></mat-datepicker>

  <button
    aria-hidden
    type="button"
    class="btn date-picker-button calendar"
    (click)="picker.open()"
    [disabled]="disableControl"
  ></button>
</div>

<ng-template #inlineCalendar>
  <!-- Can not use mat-calendar as a form control -->
  <mat-calendar
    [selected]="dateControl.value"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [dateFilter]="matFilter"
    (selectedChange)="onInlineDateChanged($event)"
  ></mat-calendar>
</ng-template>
